import styled from 'styled-components';

import { Positioner } from 'ui/inputs/InputStyles';
import { useFieldErrorTheme } from './utils';
import { ValidationError } from './types';

const StyledPositioner = styled(Positioner)`
  flex-direction: row;
  column-gap: ${({ theme }) => theme.spacing.values.quarter};
`;

type ErrorInlineTextProps = {
  hasError?: boolean;
  hasWarning?: boolean;
  validationError?: ValidationError;
};

interface ErrorInlineTextCondition extends ErrorInlineTextProps {
  condition: boolean;
}

export const ErrorInlineText = ({
  hasError = false,
  hasWarning = false,
  validationError,
}: ErrorInlineTextProps) => {
  const errorTheme = useFieldErrorTheme(hasError, hasWarning);

  if (!errorTheme) return null;
  const { Icon, errorMessage, errorColor } = errorTheme;
  const renderedErrorMessage =
    validationError?.subMessage ?? validationError?.errorMessage ?? errorMessage;
  return (
    <>
      {!!errorTheme && (
        <StyledPositioner>
          <Icon color={errorColor} />
          {renderedErrorMessage}
        </StyledPositioner>
      )}
    </>
  );
};

export const constructErrorInlineText = ({
  condition,
  hasError,
  hasWarning,
  validationError,
}: ErrorInlineTextCondition) => {
  if (!condition) return;
  return (
    <ErrorInlineText
      hasError={hasError}
      hasWarning={hasWarning}
      validationError={validationError}
    />
  );
};
